import { createReducer } from '@reduxjs/toolkit'
import { createBuilder } from 'packages/redux-toolkit'

import { login, logout, setAuthenticated } from './actions'

interface ProfileState {
  loading: boolean
  authenticated: boolean
  ready: boolean
  error: string | null
}

const initialState: ProfileState = {
  loading: false,
  authenticated: false,
  ready: false,
  error: null,
}

export const profileReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(setAuthenticated, (state, { payload }) => {
      state.authenticated = payload
      state.ready = true
    })

    .addCase(login.pending, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(login.rejected, (state, { payload }) => {
      state.loading = false
      state.authenticated = false
      state.error = payload
    })
    .addCase(login.fulfilled, (state) => {
      state.loading = false
      state.authenticated = true
      state.error = null
    })

    .addCase(logout, (state) => {
      state.authenticated = false
      state.ready = true
    })
})
